import { Label } from '@creanizer/ui'
import { Textarea } from '@creanizer/ui'
import { Alert, AlertDescription } from '@creanizer/ui'
import { Lightbulb } from 'lucide-react'
import type { SkillInput } from '@creanizer/types'

interface SkillFormIdeaProps {
  input: SkillInput
  onChange: (input: SkillInput) => void
}

export function SkillFormIdea({ input, onChange }: SkillFormIdeaProps) {
  return (
    <div className="space-y-6">
      <Alert>
        <Lightbulb className="h-4 w-4" />
        <AlertDescription>
          アイディアやコンセプトから詳細なスキルを生成します。
          思いついたアイディアを自由に入力してください。
        </AlertDescription>
      </Alert>

      <div className="space-y-2">
        <Label htmlFor="ideaText">スキルのアイディア</Label>
        <Textarea
          id="ideaText"
          value={input.ideaText || ''}
          onChange={(e) => onChange({ ...input, ideaText: e.target.value })}
          placeholder="例: 時間を一瞬止めて敵の攻撃を回避し、その隙に反撃する技。ただし使用者の体にも負担がかかる。"
          rows={8}
        />
        <p className="text-sm text-muted-foreground">
          スキルのコンセプト、効果、制限、演出などを自由に記述してください
        </p>
      </div>
    </div>
  )
}
